import PropTypes from 'prop-types';
import useGlobalMarkupOptions from './useGlobalMarkupOptions';
export { useGlobalMarkupOptions };
/**
 * Component GlobalMarkupOptions accepts an object as `children`, which behaves exactly as the `nlOpts` option to nw-app-module.
 * See https://github.com/NerdWallet/nw-app-module#globalmarkupoptions-component-or-useglobalmarkupoptions-hook for documentation on usage.
 * The component renders nothing.
 *
 * @param {object} children - nlOpts object
 */

var GlobalMarkupOptions = function GlobalMarkupOptions(_ref) {
  var children = _ref.children;
  useGlobalMarkupOptions(children);
  return null;
};

GlobalMarkupOptions.propTypes = {
  children: PropTypes.object // eslint-disable-line react/forbid-prop-types

};
export default GlobalMarkupOptions;